import { Box } from '@common-fe/common-fe';
import styled from 'styled-components';

interface FixedBarProps {
  $left?: number;
  $width?: number;
}

export const FixedBar = styled(Box)<FixedBarProps>`
  position: fixed;
  bottom: 0;
  left: ${({ $left }) => `${$left ?? 0}px`};
  width: ${({ $width }) => ($width ? `${$width}px` : '100%')};
  z-index: 10;
  box-shadow: 0px -4px 16px rgba(0, 0, 0, 0.08);
`;

export const Divider = styled.div`
  width: 1px;
  height: ${({ theme }) => theme.spacings.spacing32};
  background-color: ${({ theme }) => theme.colors.border1};
`;
